import { Card, CardBody, Col } from "reactstrap";
import DropdownForm from "./DropdownForm";
import DropdownText from "./DropdownText";
import { UniqueDropdownTitle } from "../../../../constants";
import { UniqueDropdownSubTitle } from "../../../../data/uiKits/Dropdown";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";

const UniqueDropdown = () => {
  return (
    <Col sm="6">
      <Card>
        <CommonCardHeader title={UniqueDropdownTitle} span={UniqueDropdownSubTitle} />
        <CardBody className="rtl-dropdown">
          <div className="common-flex">
            <DropdownForm />
            <DropdownText />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default UniqueDropdown;
